import React from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import AdminSidebar from "./AdminSidebar";
import ProjectSidebar from "./ProjectSidebar";

function Sidebar({ onNavigate, userData, statusRefresh, isSidebarClosed, setIsSidebarClosed, isLoading }) {
    const { t, changeLanguage, language } = useLanguage();
    const currentPath = window.location.pathname;

    if(!isLoading){
        if (currentPath.includes("control_panel")) {
            return (
                <AdminSidebar
                    onNavigate={onNavigate}
                    userData={userData}
                    statusRefresh={statusRefresh}
                    isSidebarClosed={isSidebarClosed}
                />
            );
        } else if (currentPath.includes("project_panel")) {
            return (
                <ProjectSidebar
                    onNavigate={onNavigate}
                    userData={userData}
                    statusRefresh={statusRefresh}
                    isSidebarClosed={isSidebarClosed}
                    setIsSidebarClosed={setIsSidebarClosed}
                />
            );
        }  
    } else {
        return (
            <div className={`sidebar_cont_loading ${currentPath.includes("project_panel") ? "sidebar_cont_loading_pj" : "sidebar_cont_loading_cp"}`}>
                <div className="loading_mex_cont">
                    {Array.from({ length: 8 }).map((_, index) => (
                        <div className="loading_links fade-in" key={index}></div>
                    ))}
                    <div className="loading_cloud fade-in"></div>
                </div>
            </div>
        );
    }
}

export default Sidebar;
